export const AUTH_ERROR = "auth/AUTH_ERROR";
export const AUTH_REDIRECT = "auth/AUTH_REDIRECT";
export const LOG_IN = "auth/LOG_IN";
export const SET_USER = "auth/SET_USER";
export const LOG_OUT = "auth/LOG_OUT";
export const DELETE_USER = "auth/DELETE_USER";
export const SET_CURRENT_ORGANIZATION = "auth/SET_CURRENT_ORGANIZATION";
